module.exports = __webpack_public_path__ + "img/wujinmu2.1c7174f9.jpg";